{
	"title": "Politica de confidențialitate",
	"backTitle": "Înapoi"
}
